import "@/App.css";
import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { initPostHog, posthog } from "./lib/analytics";

const Landing = lazy(() => import("./pages/Landing"));
const BlogList = lazy(() => import("./pages/BlogList"));
const BlogPost = lazy(() => import("./pages/BlogPost"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));

initPostHog();

/** Capture a $pageview whenever the React Router location changes and scroll to top. */
function PostHogAndScroll() {
  const location = useLocation();
  
  useEffect(() => {
    // 1. Capture PostHog pageview
    if (process.env.REACT_APP_POSTHOG_KEY) {
      posthog.capture("$pageview");
    }
    
    // 2. Scroll to top on every navigation
    window.scrollTo(0, 0);
  }, [location.pathname, location.search]);
  
  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <PostHogAndScroll />
          <Suspense fallback={<div className="min-h-screen bg-white" />}>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
